import React from "react";

export default function DeleteAccountPage() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12">
      {/* Logo Section */}
      <div className="text-center mb-6">
        <img src="/logo.png" alt="Logo" className="w-32 h-auto mx-auto" />
      </div>

      <h1 className="text-4xl font-bold mb-6 text-center">How to Delete Your MSME Account</h1>
      
      <div className="space-y-6">
        <p>
          If you wish to delete your MSME account and all associated data, please follow the steps below:
        </p>

        {/* Step 1 */}
        <div className="space-y-3">
          <h3 className="text-2xl font-semibold">Step 1: Open the MSME App</h3>
          <p>Launch the MSME app on your mobile device.</p>
        </div>

        {/* Step 2 */}
        <div className="space-y-3">
          <h3 className="text-2xl font-semibold">Step 2: Log in to Your Account</h3>
          <p>Ensure you're logged into the account that you wish to delete. You will need to be signed in to proceed with the account deletion process.</p>
        </div>

        {/* Step 3 */}
        <div className="space-y-3">
          <h3 className="text-2xl font-semibold">Step 3: Go to Account Settings</h3>
          <p>Tap on your profile icon located at the top-left corner of the app.</p>
        </div>

        {/* Step 4 */}
        <div className="space-y-3">
          <h3 className="text-2xl font-semibold">Step 4: Navigate to Account Deletion</h3>
          <p>In the Settings menu, tap on the pencil icon to edit the Account section.</p>
          <p>Here, look for the Delete Account option.</p>
          <p>Tap on Delete Account, which will be highlighted in red for easy identification.</p>
        </div>

        {/* Step 5 */}
        <div className="space-y-3">
          <h3 className="text-2xl font-semibold">Step 5: Confirm Account Deletion</h3>
          <p>A confirmation prompt will appear, asking if you're sure you want to delete your account and all associated data.</p>
          <p>Once you’re sure, confirm by tapping Delete Account.</p>
        </div>

        {/* Important Note */}
        <div className="bg-yellow-100 p-4 rounded-lg">
          <p className="font-semibold">Please note:</p>
          <p>This action is permanent and irreversible. All data associated with your account will be permanently deleted, including your order history, personal information, and preferences.</p>
        </div>
              {/* Footer Section */}
      <footer className="text-center mt-16 text-sm text-gray-500">
        <p>&copy; {new Date().getFullYear()} MSME. All Rights Reserved.</p>
      </footer>
      </div>
    </div>
  );
}
